import { useEffect, useRef, useState } from 'react'
import { IoAddOutline } from 'react-icons/io5'
import TextBox from 'devextreme-react/text-box';
import { useLocation } from 'react-router-dom';
import { useDiscount } from '../../Providers/DiscountProvider';
import { RxCross2 } from "react-icons/rx";
import { useCart } from '../../Providers/CartProvider';
import InformationErrorModal from './Modals/InformationErrorModal';
import { ConvertPriceToString } from '../../Helpers/CustomConverter';
import { useOffers } from '../../Providers/OffersProvider';

const DiscountCode = () => {
    const location = useLocation()
    const { voucher, handleUseVoucher, handleClearVoucher, voucherConditions } = useDiscount()
    const { cartItems, cartTotalGross, orderFromOfferTotalGross } = useCart()
    const { orderItemsFromOffer } = useOffers()

    const [isInputVisible, setIsInputVisible] = useState(false)
    const [discountCode, setDiscountCode] = useState(voucher || '')
    const [showVoucherErrorModal, setShowVoucherErrorModal] = useState(false)

    const excludedPaths = ['/savedbaskets']

    const isVoucherConfirmed = !voucher || voucher.trim() == '' || voucher == 'null' ? false : true
    const plusButtonStyle = isVoucherConfirmed ? 'collapse' : ''

    useEffect(() => { //Sprawdanie minimalnej ceny dla standardowego zamówienia        
        if (voucher && voucher.trim() != '' && cartTotalGross > 0 && orderFromOfferTotalGross == 0) {
            if (voucherConditions && voucherConditions.minValue > 0) {
                if (cartTotalGross < (voucherConditions.minValue * (1 - voucherConditions.discount / 100))) {
                    setShowVoucherErrorModal(true)
                }
            }
        }
    }, [cartTotalGross, voucher])

    useEffect(() => { //Sprawdzanie minimalnej ceny dla zamówienia z oferty
        if (voucher && voucher.trim() != '' && orderFromOfferTotalGross > 0) {
            if (voucherConditions && voucherConditions.minValue > 0) {
                if (orderFromOfferTotalGross < (voucherConditions.minValue * (1 - voucherConditions.discount / 100))) {
                    setShowVoucherErrorModal(true)
                }
            }
        }
    }, [orderFromOfferTotalGross, voucher])

    if (excludedPaths.includes(location.pathname.toLowerCase())) {
        return null
    }
    if (!cartItems || !cartItems.basketItems || cartItems.basketItems.length == 0 && (!orderItemsFromOffer || orderItemsFromOffer.length == 0)) {
        return null
    }
    return (
        <>
            <InformationErrorModal
                show={showVoucherErrorModal}
                setShow={() => {
                    handleClearVoucher()
                    setShowVoucherErrorModal(false)
                }}
                title={'Uwaga minimalna wartośc zamówienia!'}
                message={<>
                    <span>{`Wpisany kod rabatowy wymaga zamówienia z minimum ${ConvertPriceToString(voucherConditions.minValue, null)} PLN.`}</span>
                    <br />
                    <span>{`Aby wykorzystać kod spełnij podany warunek.`}</span>
                </>}
                isError={true}
                showCloseButton={false}
            />
            <div className='row'>
                <div className="col-6">
                    <span>Kod rabatowy</span>
                </div>
                <div className={`${plusButtonStyle} col-6 text-end`}>
                    <span onClick={() => setIsInputVisible(prev => !prev)}><IoAddOutline cursor={'pointer'} size={25} /></span>
                </div>
            </div>
            <MiddleSection
                isInputVisible={isInputVisible}
                isVoucherConfirmed={isVoucherConfirmed}
                discountCode={discountCode}
                setDiscountCode={setDiscountCode}
                handleUseVoucher={handleUseVoucher}
                voucher={voucher}
                handleClearVoucher={handleClearVoucher}
                setIsInputVisible={setIsInputVisible}
            />
        </>
    )
}

const MiddleSection = ({ isInputVisible, isVoucherConfirmed, discountCode, setDiscountCode, handleUseVoucher, voucher, handleClearVoucher, setIsInputVisible }) => {
    const textBoxRef = useRef(null)

    useEffect(() => {
        if (isInputVisible && textBoxRef.current) {
            setTimeout(() => {
                textBoxRef.current.instance.focus()
            }, 100)
        }
    }, [isInputVisible])

    const handleKeyDown = (e) => {
        if (e.event.key === 'Enter') {
            handleEnterDiscountCode()
        }
    }

    const handleEnterDiscountCode = async () => {
        const result = await handleUseVoucher(discountCode)
        if (result) {
            setIsInputVisible(false)
        }
    }

    if (isInputVisible) {
        return (<div className="row mt-3">
            <div className="col">
                <TextBox
                    ref={textBoxRef}
                    placeholder="Wpisz kod rabatowy"
                    value={discountCode}
                    onValueChanged={(e) => setDiscountCode(e.value)}
                    valueChangeEvent="keyup"
                    showClearButton={true}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <div className="col-3">
                <button type="button" className="btn btn-outline-success" onClick={handleEnterDiscountCode}>Zatwierdź</button>
            </div>
        </div>)
    }
    else if (isVoucherConfirmed) {
        return (<div className='row'>
            <div className="col-4">
                <span>Użyty kod:</span>
            </div>
            <div className="col">
                <span>{voucher}</span>
            </div>
            <div className="col-auto">
                <RxCross2 size={20} className='element-pointer' color='var(--error-color)' onClick={() => {
                    setDiscountCode('')
                    handleClearVoucher()
                }} />
            </div>
        </div>)
    }
}

export default DiscountCode